import { BlockchainID, Web3Address } from 'multirpc-sdk';

import { AppDispatch } from 'store';
import { web3Api } from 'store/queries';

import { fetchProjectWhitelistBlockchains } from '../fetchProjectWhitelistBlockchains';

export interface UpdateProjectWhitelistBlockchainsParams {
  blockchains: BlockchainID[];
  dispatch: AppDispatch;
  teamAddress?: Web3Address;
  userEndpointToken: string;
}

export const updateProjectWhitelistBlockchains = ({
  blockchains,
  dispatch,
  teamAddress,
  userEndpointToken,
}: UpdateProjectWhitelistBlockchainsParams) => {
  dispatch(
    web3Api.util.updateQueryData(
      fetchProjectWhitelistBlockchains.name as never,
      { group: teamAddress, token: userEndpointToken } as never,
      () => blockchains,
    ),
  );
};
